const sameOnEveryLanguage = {
	'Test': 'Test!',
	'Logo': 'Logo',
	'Involved': 'Involved',
	'Media Store': 'Media library',
	'Customer name': 'Customer name',
	'Map Marker': 'Map Marker',
	'Company information': 'Company information',

	'Download {name}': 'Download {name}',

	'Company name': 'Company name',

	'Admin information': 'Admin information',
	'Leader': 'Leader',
	'Contacts': 'Contacts',
	'Roles': 'Roles',
	'Irrevocably delete this account.': 'Irrevocably delete this account.',

	'Someone is currently editing this Presentation. Please try again later.': 'Someone is currently editing this Presentation. Please try again later.',
	'Someone is currently editing this User. Please try again later.': 'Someone is currently editing this User. Please try again later.',


	'Email Domain':'E-Mail Domain',
	'If the domain is set, only partners with an associated e-mail address can be added.': 'Wenn die Domain gesetzt ist, können nur Partner mit einer dazugehörigen E-Mail Adresse hinzugefügt werden.',
}

export default {
	en: {
		...sameOnEveryLanguage,
		'Contacts: Show'		: 'Show',
		'Contacts: Typ'			: 'Typ',
		'Save Image'			: 'Save Image',

		'Choose an image'		: 'Choose an image',
		'Hold left mouse button to move picture. Use Mousewheel to zoom in & out.': 'Hold left mouse button to move picture. Use Mousewheel to zoom in & out.',

		'en'					: 'English',
		'de'					: 'German',

		'Partner Leader'		: 'Partner Leader',
		'Partner Company'		: 'Partner Company',
		'Delete Presentation'	: 'Delete Presentation',
		'Successfull Deleted'	: 'Successfull Deleted',

		'Your logouts successfull' : 'Your logouts successfull',
		'Chart is fixed'		: 'Chart is fixed',

		'404 nothing found'		: '404 nothing found',
		'There are errors in the Form': 'There are errors in the Form',
		'Email address' 		: 'Email address',
		'Innovative Minutes'	: 'Innovative Minutes',
		'Successfull saved'		: 'Successfull saved',
		'Back to {name}'		: 'Back to {name}',

		'Mobile'				: 'Mobile',

		// template names
		"Start Screen": "Start Screen",
		"Intro Screen": "Intro Screen",
		"Contact Screen": "Contact Screen",
		"Kunde Start": "Kunde Start",
		"About KM 01": "About KM 01",
		"Market Share": "Market Share",
		"About KM 02 Video-BG": "About KM 02 Video-BG",
		"About KM 03": "About KM 03",
		"About KM 04": "About KM 04",
		"About KM 05": "About KM 05",
		"About KM 06": "About KM 06",
		"About KM 06 Intro": "About KM 06 Intro",

		"Template Partner 01": "Template Partner 01",
		"Video Chapter Chart": "Video Chapter Chart",
		"Bizhub Ready": "bizhub Ready",
		"Reifegrad": "Reifegrad",
		"Digital Matrix": "Digital Matrix",
		"End Screen": "End Screen",
		"KM Standard Intro": "KM Default Intro",
		"KM Standard 01": "KM Default 01",
		"KM Standard 02": "KM Default 02",
		"KM Standard 03": "KM Default 03",
		"Standard Template Intro": "Default Template Intro",

		"Column: image": 'Image',
		"Column: this": 'Name',
		"Column: mainrole": 'Role',
		"Column: subrole": 'Bereich',
		"Column: leader": 'Responsible',
		"Column: managers": 'Partner leader',
		"Column: customers": 'Customers',
		"Column: partners": 'Partners',
		"Column: patners": 'Partners',
		"Column: customernumber": "Customer number",


		'New {name}'			: 'New {name}',			// mainnav
		'Create new {name}'		: 'Create new {name}',	// forms
		'Edit {name}'			: 'Edit {name}',		// forms
		'My {name}'				: 'My {name}',			// mainnav
		'Order by {name}'		: 'Order by {name}',	// mainnav


		'Create'				: 'Create',
		'Create new'			: 'Create new',
		'Save'					: 'Save',
		'Save {name}'			: 'Save {name}',
		'Edit'					: 'Edit',
		'Cancel'				: 'Cancel',
		'See all'				: 'See all',
		'None'					: 'None',
		'Delete'				: 'Delete',
		'delete'				: 'delete',
		'Confirm'				: 'Confirm',
        'Close'					: 'Close',
        'Download'				: 'Offline Version',

        'Delete User'			: 'Delete User',
		'Do you really want to delete this user.': 'Do you really want to delete this user.',

		// roles
		'Marketing'				: 'Marketing',
		'KM Sales'				: 'KM Sales',
		'KM Sales Leader'		: 'KM Sales Leader',
		'KM Sales Leaders'		: 'KM Sales Leaders',
		'Project Business'		: 'Project Business',
		'Partner Business'		: 'Partner Business',
		'Partner Sales'			: 'Partner Sales',
		'Customer'				: 'Customer', 				//singular
		'Customers'				: 'Customer', 				//plural
		'Partner'				: 'Partner',				//singular
		'Partners'				: 'Partner',				//plural

		// Nav
		'Dashboard'				: 'Dashboard',
		'Infoguide'				: 'Infoguide',
		'Presentation'			: 'Presentation',
		'Presentations'			: 'Presentations',
		'Master Slides'			: 'Master Slides',
		'Styleguide'			: 'Styleguide',
		'Translations'			: 'Translations',
		'Processwire'			: 'ProcessWire CMS',

		'View'					: 'View',
		'Copy Link'				: 'Copy Link',
		'Settings'				: 'Settings',

		// system
		'Nothing Found'			: 'Nothing Found',

		// topbar
		'Logout'				: 'Logout',
		'Account'				: 'Account',
		'Switch to'				: 'Switch to',



		//dashboard
		'Latest presentation'	: 'Latest presentation',
		'Latest customer'		: 'Latest customer',
		'Next appointment'		: 'Next appointment',

		// listing
		'Final'					: 'Final',
		'final'					: 'Final',
		'Draft'					: 'Draft',
		'draft'					: 'Draft',
		'Preview'				: 'Preview',
		'preview'				: 'Preview',
		'Archive'				: 'Archiv',
		'archive'				: 'Archiv',

		'Progress Status'		: 'Progress Status',
		'My'					: 'My',
		'All'					: 'All',

		'Search ...'			: 'Search ...',
		'Name'					: 'Name',
		'Subroles'				: 'Subroles',
		'Title'					: 'Title',
		'Last edit'				: 'Last edit',
		'Appointment'			: 'Appointment',
		'Created by'			: 'Created by',

		// pageing
		'Page'					: 'Page',
		'to'					: 'to',

		// editor
		'show Chart'			: 'show Chart',
		'hide Chart'			: 'hide Chart',
		'delete Chart'			: 'delete Chart',
		'edit Charttitle'		: 'edit Charttitle',
		'edit Settings'			: 'edit Settings',
		'save Presentation'		: 'save Presentation',
		'view Presentation'		: 'view Presentation',
		'copy Presentationlink' : 'copy Presentationlink',

		// presentation form
		'Presentation name'		: 'Presentation name',
		'Without'				: 'Without',
		'Organization'			: 'Organization',
		'Appointment'			: 'Appointment',

		// userform
		'Personal information'	: 'Personal information',
		'Corporate information'	: 'Corporate information',
		'Corporate Logo'		: 'Corporate Logo',
		'Portrait Photo'		: 'Portrait Photo',
		'Salutation'			: 'Salutation',
		'choose'					: 'choose',
		'Mr'						: 'Mr',
		'Mrs'						: 'Mrs',
		'Other'						: 'Other',
		'Contact'				: 'Contact',
		'Organisation'			: 'Organisation',
		'Customer Number'		: 'Customer Number',
		'Corporate name'		: 'Corporate name',
		'First name and surname': 'First name and surname',
		'Firstname'				: 'Firstname',
		'Your firstname'		: 'Your firstname',
		'Surname'				: 'Surname',
		'Your surname'	     	: 'Your surname',
		'Titel'					: 'Title',
		'Department'			: 'Department',
		'Company Address'		: 'Company Address',
		'Adresse'				: 'Adresse',
		'Email Address'			: 'Email Address',
		'Phone'					: 'Phone',
		'Password'				: 'Password',
		'Password Confirmation' : 'Password Confirmation',
		// placeholder
		'Assistant Manager'		: '',
		'Customer Management Dept.' : '',
		'Konica Minolta Hauptstraße 42, 10400 Musterhausen' : '',
		'maria.musterfrau@konicaminolta.de'	: '',
		'max.mustermann@konicaminolta.de'	: '',
		'Role'					: 'Function',
		'After submitting this form, an automatic e-mail will be sent with login information to the specified address.': 'After submitting this form, an automatic e-mail will be sent with login information to the specified address.',
		'User Slides'			: 'User Slides',
		'to the editor'			: 'to the editor',

		// chart fields

		'Field: contacts'				: 'Contact Person',
		'Field: Contacts'				: 'Contact Card',
		'Field: background-image'		: 'Background Image',
		'Field: background-video'		: 'Background Video',
		'Field: title'					: 'Title',
		'Field: headline'				: 'Headline',
		'Field: subheadline'			: 'Subheadline',
		'Field: sub-headline'			: 'Subheadline',
		'Field: sub-headline-1'			: 'Subheadline',
		'Field: sub-headline-2'			: 'Subheadline',
		'Field: subheadline1'			: 'Subheadline',
		'Field: subheadline2'			: 'Subheadline',
		'Field: headline-left'			: 'Headline left',
		'Field: headline-right'			: 'Headline right',
		'Field: text'					: 'Text',
		'Field: text1'					: 'Text',
		'Field: text-1'					: 'Text',
		'Field: text2'					: 'Text',
		'Field: text-2'					: 'Text',
		'Field: text-left'				: 'Text left',
		'Field: text-right'				: 'Text right',
		'Field: image-gfx'				: 'Image',
		'Field: image-logo'				: 'Image (Logo)',
		'Field: kunde-image-halfsize'	: 'Image',
		'Field: image_left'				: 'Image left',
		'Field: image_right'			: 'Image right',
		'Field: right-map'				: 'Map',


		// editor
		'new Slide'				: 'new Slide',
		'new Child Slide'		: 'new Child Slide',

		// login
		'Your account is currently locked. Please contact our staff..': 'Your account is currently locked. Please contact our staff..',
		'Check your user data and try again.': 'Check your user data and try again.',
		'Your account may be locked!': 'Your account may be locked!',
		'Sign in'				: 'Sign in',
		'Password forgot?'		: 'Password forgot?',
		'DEV MODE'				: 'DEV MODE',
		system: {
			NotFound: '404 - Not found'
		},
  	},
  	de: {
  		...sameOnEveryLanguage,

		'Contacts: Show'		: 'Anzeigen',
		'Contacts: Typ'			: 'Type',
		'Save Image'			: 'Bild speichern',

  		'Choose an image'		: 'Wählen Sie ein Bild',
  		'Hold left mouse button to move picture. Use Mousewheel to zoom in & out.': 'Bei gedrückter linker Maustaste das Bild bewegen. Mit dem Scrollrad ein- und auszoomen.',

		'en'					: 'Englisch',
		'de'					: 'Deutsch',

		'Partner Leader'		: 'Partner Verkaufsleiter',
		'Partner Company'		: 'Partner Firma',
		'Delete Presentation'	: 'Präsentation löschen',
		'Successfull Deleted'	: 'Erfolgreich gelöscht',

		'Your logouts successfull' : 'Ihre Abmeldung war erfolgreich',
		'Chart is fixed'		: 'Folie ist fixiert',

		'404 nothing found'		: '404 nothing found',
		'There are errors in the Form': 'Fehler im Formular',
		'Email address' 		: 'E-Mail-Adresse',
		'Innovative Minutes'	: 'Innovative Minutes',
		'Successfull saved'		: 'Erfolgreich gespeichert',
		'Back to {name}'		: 'Zurück zu {name}',

		'Mobile'				: 'Mobile',

		// template names
		"Start Screen": "Startseite",
		"Intro Screen": "Introseite",
		"Contact Screen": "Kontaktseite",
		"Kunde Start": "Kunde Start",
		"About KM 01": "Über KM 01",
		"Market Share": "Marktanteil",
		"About KM 02 Video-BG": "Über KM 02 Video-BG",
		"About KM 03": "Über KM 03",
		"About KM 04": "Über KM 04",
		"About KM 05": "Über KM 05",
		"About KM 06": "Über KM 06",
		"About KM 06 Intro": "Über KM 06 Intro",

		"Template Partner 01": "Template Partner 01",
		"Video Chapter Chart": "Video Kapitel Chart",
		"Bizhub Ready": "bizhub Ready",
		"Reifegrad": "Reifegrad",
		"Digital Matrix": "Digitale Matrix",
		"End Screen": "Abschlußseite",
		"KM Standard Intro": "KM Standard Intro",
		"KM Standard 01": "KM Standard 01",
		"KM Standard 02": "KM Standard 02",
		"KM Standard 03": "KM Standard 03",
		"Standard Template Intro": "Standard Template Intro",


		"Column: image": 'Bild',
		"Column: this": 'Name',
		"Column: mainrole": 'Funktion',
		"Column: subrole": 'Bereich',
		"Column: leader": 'Verantwortlich',
		"Column: managers": 'Partner Verkaufsleiter',
		"Column: customers": 'Kunden',
		"Column: partners": 'Partner',
		"Column: patners": 'Partner',
		"Column: customernumber": "Kundennr.",


	  	'New {name}'			: 'Neu {name}',			// mainnav
		'Create new {name}'		: '{name} neu erstellen',	// forms
		'Edit {name}'			: '{name} bearbeiten',		// forms
		'My {name}'				: 'Mein {name}',			// mainnav
		'Order by {name}'		: 'Nach {name} sortieren',	// mainnav



  		'Create'				: 'Erstellen',
		'Create new'			: 'Neuen erstellen',
		'Save'					: 'Speichern',
		'Save {name}'			: 'Speicher {name}',
		'Edit'					: 'Bearbeiten',
		'Cancel'				: 'Abbrechen',
		'See all'				: 'Alle ansehen',
		'None'					: 'Keine',
		'Delete'				: 'Löschen',
		'delete'				: 'löschen',
        'Confirm'				: 'Bestätigen',
        'Close'					: 'Schließen',
        'Download'				: 'Offline Version',


        'Delete User'			: 'Benutzer löschen',
        'Do you really want to delete this user.': 'Möchten Sie diesen Benutzer wirklich löschen.',

		// roles
		'Marketing'				: 'Marketing',
		'KM Sales'				: 'KM Sales',
		'KM Sales Leader'		: 'KM Sales Teamleiter',
		'KM Sales Leaders'		: 'KM Sales Teamleiter',
		'Project Business'		: 'Project Business',
		'Partner Business'		: 'Partner Business',
		'Partner Sales'			: 'Partner Sales',
		'Customer'				: 'Kunde', 				//singular
		'Customers'				: 'Kunde', 				//plural
		'Partner'				: 'Partner',				//singular
		'Partners'				: 'Partner',				//plural

		// Nav
		'Dashboard'				: 'Dashboard',
		'Infoguide'				: 'Infoguide',

		'Presentation'			: 'Präsentation',
		'Presentations'			: 'Präsentationen',
		'Master Slides'			: 'Master Folien',
		'Order by Partners'		: 'Nach Partner sortieren',
		'Order by Customers'	: 'Nach Kunden sortieren',
		'Styleguide'			: 'Styleguide',
		'Translations'			: 'Übersetzungen',
		'Processwire'			: 'ProcessWire CMS',

		'View'					: 'Ansehen',
		'Copy Link'				: 'Link kopieren',
		'Settings'				: 'Einstellungen',

		// system
		'Nothing Found'			: 'Nichts gefunden',

		// topbar
		'Logout'				: 'Abmelden',
		'Account'				: 'Kontoeinstellungen',
		'Switch to'				: 'Wechseln zu',			// switch to $channel


		//dashboard
		'Latest presentation'	: 'Neuste Präsentationen',
		'Latest customer'		: 'Neuste Kunden',
		'Next appointment'		: 'Nächsten Termine',

		// listing

		'Final'					: 'Final',
		'final'					: 'Final',
		'Draft'					: 'Entwurf',
		'draft'					: 'Entwurf',
		'Preview'				: 'Vorschau',
		'preview'				: 'Vorschau',
		'Archive'				: 'Archiv',
		'archive'				: 'Archiv',

		'Final'					: 'Final',
		'Draft'					: 'Entwurf',
		'Progress Status'		: 'Fortschrittsstatus',




		'My'					: 'Meine',
		'All'					: 'Alle',

		'Search ...'			: 'Suche ...',
		'Name'					: 'Name',
		'Subroles'				: 'Bereiche',
		'Title'					: 'Titel',
		'Last edit'				: 'Letzte Bearbeitung',
		'Appointment'			: 'Termin',
		'Created by'			: 'Erstellt von',

		// pageing
		'Page'					: 'Seite', // Seite x von x
		'to'					: 'von',

		// editor tooltips
		'show Chart'			: 'Folie zeigen',
		'hide Chart'			: 'Folie verstecken',
		'delete Chart'			: 'Folie löschen',
		'edit Charttitle'		: 'Folientitel bearbeiten',
		'edit Settings'			: 'Einstellungen bearbeiten',
		'save Presentation'		: 'Präsentation speichern',
		'view Presentation'		: 'Präsentation anzeigen',
		'copy Presentationlink' : 'Präsentationslink kopieren',

		// presentation form
		'Presentation name'		: 'Präsentationsname',
		'Without'				: 'Ohne',
		'Organization'			: 'Organisation',
		'Appointment'			: 'Termin',

		// userform
		'Personal information'	: 'Persönliche Information', 		//gruppen name
		'Corporate information'	: 'Unternehmensinformationen', 	//gruppen name
		'Corporate Logo'		: 'Unternehmenslogo',			//img
		'Portrait Photo'		: 'Portrait Foto',				//img
		'Salutation'			: 'Anrede',
		'choose'					: 'auswählen',
		'Mr'						: 'Herr',
		'Mrs'						: 'Frau',
		'Other'						: 'Andere',
		'Contact'				: 'Kontakt',
		'Organisation'			: 'Organisation',
		'Customer Number'		: 'Kunden Nr.',
		'Corporate name'		: 'Unternehmensname',
		'First name and surname': 'Vor- und Nachname',
		'Firstname'				: 'Vorname',
		'Your firstname'		: 'Ihr Vorname',
		'Surname'				: 'Nachname',
		'Your surname'	     	: 'Ihr Nachname',
		'Titel'					: 'Titel',
		'Department'			: 'Abteilung',
		'Address'				: 'Adresse',
		'Company Address'		: 'Geschäftsadresse',
		'Adresse'				: 'Adresse',
		'Email Address'			: 'E-Mail',
		'Phone'					: 'Telefon',
		'Password'				: 'Passwort',
		'Password Confirmation' : 'Passwort Bestätigung',
		// placeholder
		'Assistant Manager'		: '',
		'Customer Management Dept.' : '',
		'Konica Minolta Hauptstraße 42, 10400 Musterhausen' : '',
		'maria.musterfrau@konicaminolta.de'	: '',
		'max.mustermann@konicaminolta.de'	: '',

		'Role'					: 'Funktion',
		'Subrole'				: 'Bereich',
		'After submitting this form, an automatic e-mail will be sent with login information to the specified address.': 'Mit absenden dieses Formulars wird automatisch eine E-Mail mit den Log-In Daten an die angegebene E-Mail-Adresse verschickt.',
		'User Slides'			: 'Benutzer Folien',
		'to the editor'			: 'Zum Editor',

		// chart fields
		'Field: contacts'				: 'Ansprechpartner',
		'Field: Contacts'				: 'Ansprechpartner Visitenkarte',
		'Field: background-image'		: 'Hintergrundbild',
		'Field: background-video'		: 'Hintergrundvideo',
		'Field: title'					: 'Folientitel',
		'Field: headline'				: 'Überschrift',
		'Field: subheadline'			: 'Zwischenüberschrift',
		'Field: sub-headline'			: 'Zwischenüberschrift',
		'Field: sub-headline-1'			: 'Zwischenüberschrift',
		'Field: sub-headline-2'			: 'Zwischenüberschrift',
		'Field: subheadline1'			: 'Zwischenüberschrift',
		'Field: subheadline2'			: 'Zwischenüberschrift',
		'Field: headline-left'			: 'Überschrift links',
		'Field: headline-right'			: 'Überschrift rechts',
		'Field: text'					: 'Text',
		'Field: text1'					: 'Text',
		'Field: text-1'					: 'Text',
		'Field: text2'					: 'Text',
		'Field: text-2'					: 'Text',
		'Field: text-left'				: 'Text links',
		'Field: text-right'				: 'Text rechts',
		'Field: image-gfx'				: 'Bild',
		'Field: image-logo'				: 'Bild (Logo)',
		'Field: kunde-image-halfsize'	: 'Bild',
		'Field: image_left'				: 'Bild links',
		'Field: image_right'			: 'Bild rechts',
		'Field: right-map'				: 'Karte',

		// editor
		'new Slide'				: 'Neue Folie',
		'new Child Slide'		: 'Neue Unterfolie',

		// login
		'Your account is currently locked. Please contact our staff..': 'Ihr Account is derzeit gesperrt. Bitte kontaktieren Sie dazu Ihren bekannten Konica Minolta Ansprechpartner.',
		'Check your user data and try again.': 'Überprüfen Sie bitte Ihre Anmeldedaten und versuchen Sie es erneut.',
		'Your account may be locked!': 'Ihr Account ist vermutlich gesperrt!',
		'Sign in'				: 'Einloggen',
		'Password forgot?'		: 'Passwort vergessen?',
		'DEV MODE'				: 'ENTWICKLUNGSUMGEBUNG',
		system: {
			NotFound: '404 - Not found'
		},
  	},
};



// WEBPACK FOOTER //
// ./src/i18n.js